// extracted by mini-css-extract-plugin
module.exports = {"container":"_1gFu_lbec7Tm3aj8VkX91E","icon":"_1cajYEUg6fGzK-H3rRnZAk"};